// sessionCookie.ts
const COOKIE_NAME = 'ak_logged_in';
const COOKIE_EXP_NAME = 'ak_login_exp'; // 期限の epoch 秒

export function setLoginCookies(maxAgeSec: number) {
  const now = Math.floor(Date.now() / 1000);
  const exp = now + maxAgeSec;

  // 値にも期限を入れておく（JSで参照するため）
  document.cookie = `${COOKIE_NAME}=1; Path=/; Max-Age=${maxAgeSec}; Secure; SameSite=Lax`;
  document.cookie = `${COOKIE_EXP_NAME}=${exp}; Path=/; Max-Age=${maxAgeSec}; Secure; SameSite=Lax`;
}

export function clearLoginCookies() {
  document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0`;
  document.cookie = `${COOKIE_EXP_NAME}=; Path=/; Max-Age=0`;
}

export function getCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function getRemainingSeconds(): number {
  const exp = parseInt(getCookie(COOKIE_EXP_NAME) || '0', 10);
  const now = Math.floor(Date.now() / 1000);
  return exp > now ? exp - now : 0;
}

export function isSessionExpired(): boolean {
  return getRemainingSeconds() <= 0;
}